module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r2n7n4r-1eedde4840df5a2a00f8fe1f39656cb4.svg";